'use strict';

angular.module('exceptionOverride', []).factory('$exceptionHandler', function () {
    return function (exception, cause) {

        console.error('exeption', exception);
        // exception.message += 'Angular Exception: "' + cause + '"';
        //throw exception;
    };
});